module.exports = __webpack_public_path__ + "static/media/flutter.67cdf4ad.svg";